// Google Consent Mode v2 helpers.
// Default state is set inline in index.html so it applies before any tag fires.
export const CONSENT_KEY = "xq_consent";

export function getStoredConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_e) {
    return null;
  }
}

export function pushConsent(consent) {
  const payload = {
    ad_storage: consent.ad ? "granted" : "denied",
    analytics_storage: consent.analytics ? "granted" : "denied",
    ad_user_data: consent.ad ? "granted" : "denied",
    ad_personalization: consent.ad ? "granted" : "denied",
    functionality_storage: "granted",
    personalization_storage: consent.analytics ? "granted" : "denied",
    security_storage: "granted"
  };
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag("consent", "update", payload);
  localStorage.setItem(CONSENT_KEY, JSON.stringify({ ...consent, ts: Date.now() }));
}

export function acceptAll() {
  pushConsent({ ad: true, analytics: true });
}

export function rejectAll() {
  pushConsent({ ad: false, analytics: false });
}
